<template>
  <div :class="wrapClass" class="wrap">
    <router-view
      :portlet-list="portletList"
      :is-search-pop="isOpenSearch"
      :potlt-info="potltInfo"
      name="header"
      @onClickTotalSearch="onSearchView"
    />
    <router-view :key="$route.fullPath" :portlet-list="portletList" name="content" @onClickTotalSearch="onSearchView"/>
    <router-view v-show="isVisible" name="footer"/>
    <router-view v-if="!isDesktop" name="bottom" @onClickTotalSearch="onSearchView"/>
    <CompFloatNav v-if="!$route.name.indexOf('Promotion') > -1" :show-ai-tutor="false" :show-goto-top="true" /><!-- AI 버튼 추후 개발 -->

    <TotalSearchMain
      v-if="isOpenSearch"
      ref="refSearchPop"
      :search-keyword="preSearchKeyword"
      @onClickTotalSearch="onSearchView"
      @click.stop
      @close="closePopup"
    />
  </div>
</template>
<script>
import TotalSearchMain from '~pages/nrw/search/TotalSearchMain'
import CompFloatNav from '@/components/pages/nrw/portlet/CompFloatNav.vue'

export default {
  name: 'NrwDefaultLayout',
  components: {TotalSearchMain, CompFloatNav},
  data () {
    return {
      portletList: [],
      menuPromoCat: null,
      isOpenSearch: false,
      preSearchKeyword: '',
      isVisible: false
    }
  },
  computed: {
    potltInfo () {
      return this.portletList.filter(item => item.potltCd === 'NRW_PROMO')[0]
    },
    wrapClass () {
      let wrapClass = {}
      if (this.$route.meta && this.$route.meta.wrapClass) {
        wrapClass[this.$route.meta.wrapClass] = true
      }

      if (this.$route.meta && this.$route.meta.hideFooter) {
        wrapClass['no-footer'] = true
      }

      return wrapClass
    },
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    }
  },
  async created () {
    // 쿠키 값 출력
    await this.fetchPortletList()
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    // NrwFooter 노출
    setVisible () {
      this.isVisible = true
    },
    // 웹 모바일 포틀릿 목록 조회
    async fetchPortletList () {
      const params = { sitePotltMenuTyp: 'MWH', mbrNo: this.getMbrNo(), langCd: this.getUserLangCd() }

      const fetchDataCallback = (data) => {
        this.portletList = data
        console.log('fetchPortletList NrwDefaultLayout portletList ==>', data)
        window.vue.getStore('courseList').commit('SET_PORTLET_LIST', this.portletList)

        this.menuPromoCat = this.portletList.filter(item => item.potltCd === 'NRW_PROMO')
        console.log('NrwDefaultLayout menuPromoCat ==>', this.menuPromoCat)
        window.vue.getStore('homeInfo').commit('SET_MENU_PROMO_CAT', this.menuPromoCat)

        // NrwFooter 노출
        this.setVisible()
      }

      // 데이터 조회
      await this.fetchData('selectHomePortletList', params, fetchDataCallback)
    },
    closePopup () {
      this.isOpenSearch = false
    },
    handleClickOutside (event) {
      const searchButton = document.querySelector('.btn_top_icon.search')
      const searchMenu = document.getElementById('mmpSearchMenu')
      const dimm = document.querySelector('.dimm')
      // const popAlert = document.querySelector('.popup_wrap.alert_type') // 팝업제외

      const isSearchButton = searchButton && searchButton.contains(event.target)
      const isSearchMenu = searchMenu && searchMenu.contains(event.target)
      // const isPopAlert = popAlert && popAlert.contains(event.target)

      // console.log('popAlert ------> ', popAlert)
      // 클릭한 요소가 검색 메뉴, 검색 버튼이 아니면 TotalSearchMain 팝업 닫음(얼럿 제외)
      if (this.isOpenSearch && this.isDesktop && !isSearchButton && !isSearchMenu && !dimm) {
        this.closePopup()
      }
    },
    onSearchView (searchedKeyword) {
      this.isOpenSearch = !this.isOpenSearch

      if (searchedKeyword !== '') {
        this.preSearchKeyword = searchedKeyword
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwDefaultLayout.vue